import { render } from "./PasiveCashView.vue?vue&type=template&id=0e52a259&ts=true"
import script from "./PasiveCashView.vue?vue&type=script&lang=ts"
export * from "./PasiveCashView.vue?vue&type=script&lang=ts"

import "./PasiveCashView.vue?vue&type=style&index=0&id=0e52a259&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__